import { types } from "mobx-state-tree";

const Location = types.model('Location', {
  code: types.identifier,
  description: types.refinement(types.string, value => value.length <= 100),
  phoneNumber: types.refinement(types.string, value => value.length <= 20),
});

export default Location;
